window.ShopifyMarketing = {}
window.ShopifyMarketing.Helpers = {}
window.ShopifyMarketing.context = {}

// =============================================
// KeyCodes
// =============================================
ShopifyMarketing.keyCodes = {
  BACKSPACE: 8,
  COMMA: 188,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  NUMPAD_ADD: 107,
  NUMPAD_DECIMAL: 110,
  NUMPAD_DIVIDE: 111,
  NUMPAD_ENTER: 108,
  NUMPAD_MULTIPLY: 106,
  NUMPAD_SUBTRACT: 109,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38,
  SHIFT: 16,
  CAPS_LOCK: 20,
  OPTION: 18
}

// =============================================
// Config
// =============================================
ShopifyMarketing.Config = function() {
  function e() {
    window.ShopifyConfig = window.ShopifyConfig || {}, this.data = window.ShopifyConfig
  }

  return e.prototype.get = function(e, t) {
    if ("undefined" == typeof t) throw new Error("Must provide a fallback value");
    return this.data.hasOwnProperty(e) ? this.data[e] : t
  },

  e.prototype.set = function(e, t) {
    this.data[e] = t
  }, new e
}()


// =============================================
// Popover
// =============================================
ShopifyMarketing.Popover = function() {
  function e(e, t) {
    this.config = Object.assign({}, {
      position: e.data("position") || "bottom",
      toggleOnlyOnClick: e.data("toggleOnlyOnClick") || !1
    }, t),
    this.$el = e,
    this.$popover = this.$el.find(".popover"),
    this.$trigger = this.$el.find(".popover-trigger"),
    this.$html = $("html, body"),
    this.show = _.bind(this.show, this),
    this.hide = _.bind(this.hide, this),
    this._mouseEnter = _.bind(this._mouseEnter, this),
    this._mouseLeave = _.bind(this._mouseLeave, this),
    this._onClick = _.bind(this._onClick, this),
    this._onKeyUp = _.bind(this._onKeyUp, this),
    this._focusOut = _.bind(this._focusOut, this),
    this._onBgClick = _.bind(this._onBgClick, this),
    this.config.toggleOnlyOnClick || (this.$el.on("mouseenter", this._mouseEnter),
    this.$el.on("mouseleave", this._mouseLeave),
    this.$el.on("focus", "*", this.show)),
    this.$el.on("focusout", "*", this._focusOut),
    this.$trigger.on({
      click: this._onClick,
      keyup: this._onKeyUp
    }),
    this.$popover.on("keyup", this._onKeyUp),
    this.isOpen = !1,
    this.isOpening = !1,
    this.init()
  }

  var t = ShopifyMarketing.keyCodes;

  return e.prototype.init = function() {
    var e = "popover--",
      t = _.uniqueId("Popover");
    this.$popover
      .addClass(e + this.config.position)
      .attr("id", t),
    this.$trigger.attr({
      "aria-expanded": "false",
      "aria-describedby": t
    })
  },

  e.prototype.show = function() {
    this.$html.on("click.popover", this._onBgClick), this.$popover.outerWidth(), this.$el.addClass("js-is-active"), this.$trigger.attr("aria-expanded", "true"), this.isOpen = !0, this.isOpening = !0, setTimeout(_.bind(function() {
      this.isOpening = !1
    }, this), 600)
  },

  e.prototype.hide = function() {
    this.$html.off(".popover"), this.$trigger.attr("aria-expanded", "false"), this.$el.removeClass("js-is-active"), this.isOpen = !1
  },

  e.prototype._focusOut = function(e) {
    e.stopPropagation(), setTimeout(_.bind(function() {
      this.$popover.find(":focus").length || this.hide()
    }, this), 10)
  },

  e.prototype._mouseEnter = function() {
    this.show()
  },

  e.prototype._mouseLeave = function() {
    this.hide()
  },

  e.prototype._onBgClick = function(e) {
    var t = $(e.target);
    this.isOpening || e.target === this.$popover || t.parents().is(this.$popover) || this.hide()
  },

  e.prototype.toggle = function() {
    this.isOpen ? this.hide() : this.show()
  },

  e.prototype._onClick = function() {
    (!this.isOpening || this.config.toggleOnlyOnClick) && this.toggle()
  },

  e.prototype._onKeyUp = function(e) {
    switch (e.keyCode) {
      case t.SPACE:
        e.preventDefault(), e.stopPropagation(), this.toggle();
        break;
      case t.ESCAPE:
        this.hide(), this.$trigger.focus()
    }
  }, e
}()

_.each($(".js-popover"), function(e) {
  new ShopifyMarketing.Popover($(e))
})


// =============================================
// Breakpoints
// =============================================
ShopifyMarketing.Breakpoints = function() {
  function e(e) {
    this.breakpoints = e || t, this.init()
  }

  var t = {
    desktop: "screen and (min-width: 67.5em)",
    tablet: "screen and (min-width: 46.875em) and (max-width: 67.4375em)",
    tabletUp: "screen and (min-width: 46.875em)",
    tabletDown: "screen and (max-width: 67.4375em)",
    phone: "screen and (max-width: 46.8125em)"
  };

  return e.prototype = t, e.prototype.init = function() {
    var e = this;
    _.each(this.breakpoints, function(t, n) {
      e[n] = t
    })
  },

  e.prototype.isDesktop = function() {
    return window.matchMedia(this.desktop).matches
  }, e
}()


// =============================================
// Accordion
// =============================================
ShopifyMarketing.Accordion = function() {
  function e(e, n) {
    this.config = Object.assign({
      itemSelector: ".accordion-item--mobile",
      itemLink: ".accordion-link",
      itemContent: ".accordion-content",
      mobileOnly: !0,
      openFirst: !0
    }, n),
    this.$el = e,
    this.$accordionItems = this.$el.find(this.config.itemSelector),
    this.$accordionLinks = this.$el.find(this.config.itemLink),
    this.$accordionContents = this.$el.find(this.config.itemContent),
    this.toggle = _.bind(this.toggle, this),
    this.enable = _.bind(this.enable, this),
    this.disable = _.bind(this.disable, this),
    this.ensureTabIndex = _.bind(this.ensureTabIndex, this),
    this.removeTabIndex = _.bind(this.removeTabIndex, this),
    this.removeStyles = _.bind(this.removeStyles, this),
    this.setInitialAriaStates = _.bind(this.setInitialAriaStates, this),
    this.removeAriaStates = _.bind(this.removeAriaStates, this),
    this._onClick = _.bind(this._onClick, this),
    this._onKeydown = _.bind(this._onKeydown, this),
    this.config.mobileOnly ? enquire.register(t.tablet, this.disable).register(t.phone, this.enable) : this.enable()
  }

  var t = new ShopifyMarketing.Breakpoints;

  return e.prototype.getCurrentItem = function(e) {
    var t = $(e.currentTarget);
    return t.closest(this.config.itemSelector)
  },

  e.prototype.toggle = function(e) {
    var t = this.getCurrentItem(e),
      n = !t.hasClass("js-is-active");
    t.toggleClass("js-is-active", n).find(this.config.itemContent).attr("aria-hidden", !n).stop().slideToggle(n).end().find(this.config.itemLink).attr("aria-expanded", n)
  },

  e.prototype.enable = function() {
    this.$el.on("click", this.config.itemLink, this._onClick),
    this.$el.on("keydown", this.config.itemLink, this._onKeydown),
    this.ensureTabIndex(),
    this.setInitialAriaStates(),
    this.config.openFirst && this.openFirst(),
    this.$el.addClass("js-is-initialized")
  },

  e.prototype.disable = function() {
    this.$el.off("click", this.config.itemLink), this.$el.off("keydown", this.config.itemLink), this.removeTabIndex(), this.removeAriaStates(), this.removeStyles(), this.$el.removeClass("js-is-initialized")
  },

  e.prototype.openFirst = function() {
    this.$accordionItems.first().not(".js-is-active").find(this.config.itemLink).trigger("click")
  },

  e.prototype.ensureTabIndex = function() {
    this.$accordionLinks.prop("tabindex", 0)
  },

  e.prototype.removeTabIndex = function() {
    this.$accordionLinks.removeAttr("tabindex")
  },

  e.prototype.removeStyles = function() {
    this.$accordionItems.removeAttr("style"), this.$accordionContents.removeAttr("style")
  },

  e.prototype.setInitialAriaStates = function() {
    var e = this.config;
    this.$accordionItems.each(function(t, n) {
      var i = $(n),
        r = _.uniqueId("Accordion");
      i.removeClass("js-is-active"), i.find(e.itemContent).attr({
        "aria-hidden": "true",
        id: r
      }), i.find(e.itemLink).attr({
        "aria-expanded": "false",
        "aria-controls": r
      })
    })
  },

  e.prototype.removeAriaStates = function() {
    this.$accordionContents.removeAttr("aria-hidden id"), this.$accordionLinks.removeAttr("aria-controls aria-expanded")
  },

  e.prototype._onKeydown = function(e) {
    e.keyCode === ShopifyMarketing.keyCodes.ENTER && (e.preventDefault(), this.toggle(e))
  },

  e.prototype._onClick = function(e) {
    return e.preventDefault(), this.toggle(e)
  }, e
}()


// =============================================
// A11yHelpers
// =============================================
ShopifyMarketing.A11yHelpers = function() {
  function e() {
    this.init(), $(".in-page-link").on("click", _.bind(function(e) {
      this.pageLinkFocus($(e.currentTarget.hash))
    }, this))
  }

  return e.prototype.init = function() {
    var e = window.location.hash;
    e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
  },

  e.prototype.trapFocus = function(e, t) {
    var n = t ? "focusin." + t : "focusin";
    e.attr("tabindex", "-1"), $(document).on(n, function(t) {
      e[0] === t.target || e.has(t.target).length || e.focus()
    })
  },

  e.prototype.removeTrapFocus = function(e, t) {
    var n = t ? "focusin." + t : "focusin";
    e.removeAttr("tabindex"), $(document).off(n)
  },

  e.prototype.pageLinkFocus = function(e) {
    e.length && (e.get(0).tabIndex = -1, e.focus().addClass("js-focus-hidden"), e.one("blur", function() {
      e.removeClass("js-focus-hidden").removeAttr("tabindex")
    }))
  }, e
}()


// =============================================
// Drawer
// =============================================
ShopifyMarketing.Drawers = function() {
  function e(e, t, n) {
    var i = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + t,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + t
    };
    return this.$nodes = {
      parent: $("body, html"),
      page: $("#PageContainer"),
      accordion: $(".DrawerNavAccordion")
    }, this.config = Object.assign(i, n), this.position = t, this.$drawer = $("#" + e), this.$drawer.length ? (this.drawerIsOpen = !1, void this.init()) : !1
  }

  var t = ShopifyMarketing.Accordion,
    n = ShopifyMarketing.Breakpoints,
    i = ShopifyMarketing.A11yHelpers,
    r = ShopifyMarketing.Config;

  return e.prototype.init = function() {
    if (this.$nodes.accordion.length) {
      var e = new t(this.$nodes.accordion, {
          mobileOnly: !1,
          openFirst: !1,
          itemSelector: ".accordion-item"
        }),
        i = this.$nodes.accordion.find(".accordion-link.active");
      i.length ? i.trigger("click") : e.openFirst()
    }
    this.$drawer.on("keydown", _.bind(this._onKeyDown, this)).on("click", _.bind(this._onClick, this)), $(this.config.open).on("click", _.bind(this.open, this)), this.$drawer.find(this.config.close).on("click", _.bind(this.close, this)), enquire.register(n.prototype.desktop, _.bind(this.close, this))
  },

  e.prototype.open = function(e) {
    return e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen || r.get("drawerIsOpen", !1) ? void this.close() : (this.$drawer.prepareTransition(), this.$nodes.parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, r.set("drawerIsOpen", this.drawerIsOpen), i.prototype.trapFocus(this.$drawer, "drawer_focus"), this.$drawer.focus(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.$nodes.page.on("touchmove.drawer", function() {
      return !1
    }), void this.$nodes.page.on("click.drawer", _.bind(function() {
      return this.close(), !1
    }, this)))
  },

  e.prototype.close = function(e) {
    var t = Object.assign({
      resetFocus: !0
    }, e);
    this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.addClass("is-transitioning"), this.$nodes.parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, r.set("drawerIsOpen", this.drawerIsOpen), _.delay(_.bind(function() {
      this.$drawer.removeClass("is-transitioning"), i.prototype.removeTrapFocus(this.$drawer, "drawer_focus"), this.$activeSource && (t.resetFocus && this.$activeSource.focus(), this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"))
    }, this), 610), this.$nodes.page.off(".drawer"))
  },

  e.prototype._onKeyDown = function(e) {
    this.drawerIsOpen && e.keyCode === ShopifyMarketing.keyCodes.ESCAPE && this.close()
  },

  e.prototype._onClick = function(e) {
    document.baseURI === e.target.href && this.close({
      resetFocus: !1
    })
  }, e
}()

ShopifyMarketing.drawer = new ShopifyMarketing.Drawers("NavDrawer", "right")
